import React from 'react';
import PropTypes from 'prop-types';

import SendSmsButton from './SendSmsButton';
import { useConstantContext } from './ConstantsContext';

const SendUnreachableSmsButton = ({
  applicationId,
  userId,
}) => {
  const { constants } = useConstantContext();
  const { smsTypes } = constants;
  return (
    <SendSmsButton
      title="Send unreachable sms"
      applicationId={applicationId}
      userId={userId}
      smsType={smsTypes.UNREACHABLE}
    />
  );
};

SendUnreachableSmsButton.propTypes = {
  applicationId: PropTypes.string,
  userId: PropTypes.string.isRequired,
};

SendUnreachableSmsButton.defaultProps = {
  applicationId: undefined,
};

export default SendUnreachableSmsButton;
